import React from "react"
import { IconColorsType } from "../"
import { camelize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "rotate"
const RotateIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M13.05 22v-2.05a7.3 7.3 0 0 0 1.662-.45 7 7 0 0 0 1.538-.85l1.4 1.45q-1.05.8-2.2 1.287a8.2 8.2 0 0 1-2.4.613m-2 0q-3.45-.45-5.725-2.988T3.05 13.05q0-1.874.712-3.513a9.2 9.2 0 0 1 1.925-2.85 9.2 9.2 0 0 1 2.85-1.925 8.7 8.7 0 0 1 3.513-.712h.15L10.65 2.5l1.4-1.45 4 4-4 4-1.4-1.4 1.6-1.6h-.2q-2.925 0-4.963 2.037Q5.05 10.125 5.05 13.05q0 2.6 1.7 4.563t4.3 2.337zm8.05-3.35-1.45-1.4q.525-.725.85-1.537a7.3 7.3 0 0 0 .45-1.663H21a8.2 8.2 0 0 1-.613 2.4q-.488 1.15-1.287 2.2m1.9-6.6h-2.05a7.3 7.3 0 0 0-.45-1.663 7.1 7.1 0 0 0-.85-1.537l1.45-1.4q.8.975 1.275 2.15T21 12.05" />
    </svg>
  )
}
export default RotateIcon
